function decode(s) {
  return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
}

export function getCookie(key: string): any {
  for (const cookie of document.cookie.split("; ")) {
    const parts = cookie.split("=");
    const name = decode(parts[0]);
    if (name === key) {
      return decode(parts.slice(1).join("="));
    }
  }
  return undefined;
}
